import _ from 'lodash-es';

export default {
  getComputedDomains(state) {
    return _.sortBy(state.domains.items, ['brandId', 'name'])
      .filter((domain) => {
        const allowedDomains = [
          'friferie.dk',
          'danskbilferie.dk',
          'allcamps.de',
          'allcamps.at',
          'allcamps.ch',
          'allcamps.nl',
          'allcamps.be',
          'allcamps.co.uk',
          'allcamps.ie',
          'allcamps.es',
          'allcamps.it',
          'lux-camp.nl',
          'nl.lux-camp.be',
          'lux-camp.hu',
          'lux-camp.co.uk',
          'lux-camp.ie',
          'lux-camp.de',
          'lux-camp.at',
          'lux-camp.ch',
          'go4holiday.nl',
        ];
        return allowedDomains.indexOf(domain.name) !== -1;
      });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/giftVoucher/getters.js